import { createAction } from "redux-actions";
import { path, prop, identity } from "ramda";
import { createSelector } from "reselect";

// Actions
export const OPEN_UPLOAD_DIALOG = "APP@UPLOAD_DIALOG::OPEN";
export const CLOSE_UPLOAD_DIALOG = "APP@UPLOAD_DIALOG::CLOSE";
export const DROP_FILE_UPLOAD_DIALOG = "APP@UPLOAD_DIALOG::DROP_FILE";

// Action Creators
export const openDialog = createAction(OPEN_UPLOAD_DIALOG);
export const closeDialog = createAction(CLOSE_UPLOAD_DIALOG);
export const dropFile = createAction(DROP_FILE_UPLOAD_DIALOG);

export const toggleDialog = () => (dispatch, getState) => {
  const isOpen = selectIsOpen(getState());
  dispatch(isOpen ? closeDialog() : openDialog());
};

// Selectors
const getUploadDialog = path(["application", "uploadDialog"]);
export const selectUploadDialog = createSelector(getUploadDialog, identity);
export const selectIsOpen = createSelector(getUploadDialog, prop("isOpen"));
export const selectFiles = createSelector(getUploadDialog, prop("files"));

// Initial State
const initialState = () => ({
  isOpen: false,
  files: []
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case OPEN_UPLOAD_DIALOG:
      return { ...state, isOpen: true };
    case CLOSE_UPLOAD_DIALOG:
      return { ...state, isOpen: false };
    case DROP_FILE_UPLOAD_DIALOG:
      return { ...state, files: action.payload };
    default:
      return state;
  }
}
